import React from "react";

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Signicat = function Signicat(props) {
  return React.createElement("svg", props, React.createElement("style", null, ".st0", "{", "fill:#293440", "}"), React.createElement("path", {
    className: "st0",
    d: "M0 17.2h7.7c0 2.7 1.1 2.9 3.3 2.9h9.4c1.6 0 3.3-.2 3.3-2.1 0-2.2-.9-2.3-10.8-2.3C1.4 15.6 0 14.2 0 8.1 0 3.5.4 0 10.2 0H21c8.9 0 9.7 3 9.7 7.4v.8H23c0-1.8-.2-2.6-3.8-2.6h-8.6c-1.7 0-2.9.6-2.9 2 0 2.2.9 2.3 9.2 2.2 12 0 14.8.7 14.8 8 0 6.8-2.3 7.9-12.5 7.9H9.8c-7 0-9.8-1.3-9.8-6.8v-1.7zM36.9.3h7.7v25.1h-7.7zM49.7 9.1c0-7.4 4.1-9.1 11.1-9.1h11.6c8.8 0 10 3.2 10 8.1v.8h-7.6c0-2.5-1.4-2.8-3.9-2.8h-8.4c-3.9 0-4.9.9-4.9 5.2v3.1c0 4.3 1 5.3 4.9 5.3h8.2c2 0 4-.3 4-2.8v-.7h-9.6V11h17.3v7.2c0 7.2-3.8 7.6-12.4 7.6h-9.3c-6.9 0-11.1-1.7-11.1-9.1l.1-7.6zM87.1.3h12l14.5 18.2V.3h7.7v25.1h-11.9L94.9 7.2h-.1v18.2h-7.7zM127 .3h7.7v25.1H127zM139.8 9.1c0-7.4 4.1-9.1 11.1-9.1h9.1c11 0 12.4 2.4 12.3 9.5h-7.7v-.7c0-1.8-1.3-2.3-3.6-2.3h-8.4c-4.1 0-4.8 1.9-4.8 5v2.7c0 3.7.8 5 4.4 5h8.2c3.5 0 4.5-.4 4.5-3.5h7.7v2.4c0 4.2-1.5 7.6-9.3 7.6h-12.4c-6.9 0-11.1-1.7-11.1-9.1V9.1zM187.2.3h10L211 25.4h-8.6l-2.3-4.4h-15.7l-2.3 4.4h-8.6L187.2.3zm.1 15.3h9.9l-5-9.4-4.9 9.4zM207.6.3H237v6.2h-10.8v18.9h-7.8V6.5h-10.8z"
  }));
};

Signicat.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 237 25.7"
};
export { Signicat };